import { useTranslation } from 'react-i18next'
import { ContentPlaceholder } from '@/components/molecules'
import classNames from 'classnames'

type UnderConstructionProps = {
    className?: string
}

export const UnderConstruction: React.FC<UnderConstructionProps> = (props) => {
    const { t } = useTranslation('translations')
    const className = classNames('h-full p-6', props.className)

    return (
        <div className={className}>
            <ContentPlaceholder
                name="under-construction"
                title={t('common.under_construction.title')}
                description={t('common.under_construction.description')}
                illustrationSrc="/assets/under-construction-illustration.svg"
                className="h-full !border-none !bg-white"
            />
        </div>
    )
}
